import { Suspense, lazy, useState } from "react";
// 리뉴얼

const ProviderRoutes = lazy(() => import("./provider"));
const MediaRoutes = lazy(() => import("./media"));
const PartnersRoutes = lazy(() => import("./partners"));

//before
const ProfitRoutes = lazy(() => import("./profit"));
const StatisticsRoutes = lazy(() => import("./statistics"));
const CalculateRoutes = lazy(() => import("./calculate"));
const ServiceRoutes = lazy(() => import("./service"));
const UserManageRoutes = lazy(() => import("./user"));
const NoticeRoutes = lazy(() => import("./notice"));
const TranslationRoutes = lazy(() => import("./translation"));
const HelpRoutes = lazy(() => import("./help"));

import { lightTheme } from "../styles/theme";
import { GlobalStyle } from "../styles/globalStyle";
import { ThemeProvider, type DefaultTheme } from "styled-components";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import Spinner from "../components/ui/Spinner";
import ScrollTop from "components/ui/ScrollTop";
import Layout from "../components/layout/Layout";
import Popup from "commons/popup/PopupController";
import LoadingView from "commons/loading/LoadingView";
import LayerController from "commons/layers/LayerController";
import { useTokenRefresh } from "store/modules/auth/authHook";
import Main from "./Main";
// import ServiceMaintenance from "./ServiceMaintenance";

const NotFound = lazy(() => import("./404"));
const PassWord = lazy(() => import("./PassWord"));
const Login = lazy(() => import("./Login"));
const PolicyRoutes = lazy(() => import("./policy"));
const SignupRoutes = lazy(() => import("./signup"));
const EntryPageRoutes = lazy(() => import("./entry"));
export const NoServicePage = lazy(() => import("pages/NotService"));

/**
 * CSR (client side rendering) 으로 화면을 구성하고 단일앱 구조를 가지기위한 방식이다
 // * @param param AppProps next.js 에서 받아온 페이지 설정하기 위한 값
 * @returns JSX.Element
 */
function RootApp(): JSX.Element {
  /**
   * styled-components Theme를 적용하기 위한
   * 모든 페이지는 이 파일을 통해서 구성된다
   */
  const [theme] = useState<DefaultTheme>(lightTheme);

  //언어
  // const { t, i18n } = useTranslation();
  useTokenRefresh();

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Popup />
        <LoadingView />
        <LayerController />
        <Routes>
          {/* 서비스 점검 할때 주석 제거 */}
          {/* <Route index element={<ServiceMaintenance />} /> */}

          {/* <Route index element={<Login />} /> */}

          <Route index element={<Main />} />
          <Route path="/login/*" element={<Login />} />

          <Route path="/policy/*" element={<PolicyRoutes />} />
          <Route path="/signup/*" element={<SignupRoutes />} />
          <Route path="/entry/*" element={<EntryPageRoutes />} />
          <Route path="/password" element={<PassWord />} />

          <Route path="/admin" element={<Layout />}>
            {/* 리뉴얼 */}
            <Route
              path="provider/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <ProviderRoutes />
                </Suspense>
              }
            />

            <Route
              path="media/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <MediaRoutes />
                </Suspense>
              }
            />

            <Route
              path="partners/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <PartnersRoutes />
                </Suspense>
              }
            />

            <Route
              path="notice/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <NoticeRoutes />
                </Suspense>
              }
            />

            <Route
              path="setting/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <UserManageRoutes />
                </Suspense>
              }
            />

            <Route
              path="help/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <HelpRoutes />
                </Suspense>
              }
            />

            {/* 구 계정설정 메뉴 */}
            {/* <Route
              path="user/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <UserManageRoutes />
                </Suspense>
              }
            />
            <Route
              path="usermanage/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <UserManageRoutes />
                </Suspense>
              }
            /> */}
            {/* <Route
              path="userinfo/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <UserManageRoutes />
                </Suspense>
              }
            /> */}

            {/* 이전 */}
            {/* <Route
              path="statistics/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <StatisticsRoutes />
                </Suspense>
              }
            /> */}
            {/* <Route
              path="profit/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <ProfitRoutes />
                </Suspense>
              }
            /> */}

            {/* <Route
              path="calculate/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <CalculateRoutes />
                </Suspense>
              }
            />
            <Route
              path="service/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <ServiceRoutes />
                </Suspense>
              }
            /> */}

            <Route
              path="calculate/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <CalculateRoutes />
                </Suspense>
              }
            />
            <Route
              path="translate/*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <TranslationRoutes />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={<Spinner text="로딩중입니다." />}>
                  <NotFound />
                </Suspense>
              }
            />
          </Route>
          <Route path="/*" element={<NotFound />} />
        </Routes>
        <ScrollTop />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default RootApp;
